
import React ,{useEffect} from "react";
import Project from "./Project";
import { data } from "../data";


export default function Projects() {

    useEffect(() => {
        const images = document.querySelectorAll('img');
  
        let intersectionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
     
            if(!entry.isIntersecting) {
              return
            }
            
            intersectionObserver.unobserve(entry.target);
            const {src} =  entry.target.dataset;
     
            if(!src ) return;
            entry.target.src = src;
            
          });
        });
     
        images.forEach(image => intersectionObserver.observe(image));


        return () => {
            intersectionObserver.disconnect();
        }
        
    },[]);
        

    return (
        <div className="projects" id="projects">
            <h1 className="display-5 mb-5 text-center"> <b>Proyectos Recientes </b></h1>
            <div className="container">
                <div className="row">
                    {
                        data.projects.map((project, index) => (<Project key={index} project={project} />))
                    }
                </div>
            </div>
            
        </div>
    )
}



